import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import * as api from 'app/shared/api/getProductDivisions';

export const DIVISIONS_LOADED = 'DIVISIONS_LOADED';
export const DIVISIONS_LOAD_FAILED = 'DIVISIONS_LOAD_FAILED';
export const SET_SELECTED_DIVISION = 'SET_SELECTED_DIVISION';

export function loadDivisions() {
  return async (dispatch: ThunkDispatch<any, any, Action>) => {
    try {
      const divisions = await api.getAllProductDivisions();
      dispatch({ type: DIVISIONS_LOADED, divisions });
      if (divisions.length > 0) {
        dispatch(setSelectedDivision(String(divisions[0].id)));
      }
    } catch (error: any) {
      dispatch({ type: DIVISIONS_LOAD_FAILED, error: error.message || 'Failed to load divisions' });
    }
  };
}

export function setSelectedDivision(id: string) {
  return {
    type: SET_SELECTED_DIVISION,
    id,
  };
}